import { render, staticRenderFns } from "./AccessAdministratorUser.vue?vue&type=template&id=461f73d3&"
import script from "./AccessAdministratorUser.vue?vue&type=script&lang=js&"
export * from "./AccessAdministratorUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports